import { boolean, number, object, mixed } from "yup"
import { ID } from "../yup.common"
const cropModel = object({
  id: ID,
  numberOfSaplings: number().min(0).label("Saplings"),
  growingCycle: number().min(0).label("Growing Cycle"),
  sowingDate: mixed().label("Sowing Date"),
  isArchived: boolean(),
  harvestingDate: mixed().label("Harvesting Date"),
  variety: mixed().label("Variety"),
  generatePoPlotWise: boolean().label("Purchase Order"),
})

export default cropModel
